import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  // Add debug logging
  useEffect(() => {
    console.log('PrivateRoute - Auth state:', { currentUser, loading });
  }, [currentUser, loading]);

  if (loading) {
    console.log('PrivateRoute - Still loading auth state...');
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A] bg-noise">
        <div className="relative">
          <div className="absolute -inset-10 bg-gradient-to-r from-violet-600 to-teal-600 rounded-full opacity-30 blur-lg animate-pulse"></div>
          <div className="relative flex flex-col items-center">
            <div className="w-16 h-16 border-4 border-teal-400 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-white/70">Loading your account...</p>
          </div>
        </div>
      </div>
    );
  }
  
  if (!currentUser) {
    console.log('PrivateRoute - No authenticated user, redirecting to login');
    return <Navigate to="/login" />;
  }

  console.log('PrivateRoute - User authenticated, rendering protected content');
  return <>{children}</>;
};

export default PrivateRoute; 